import * as React from 'react';
import classNames from 'classnames';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const styles = require('./styles.pcss');

type Props = {};

const ExpenseReportsTableHeader = (props: Props) => (
  <TableHead>
    <TableRow>
      <TableCell className={styles.tableHead}>Report</TableCell>
      <TableCell className={styles.tableHead}>Reimbursement Date</TableCell>
      <TableCell className={styles.tableHead}>Amount</TableCell>
      <TableCell className={styles.tableHead}>Status</TableCell>
      <TableCell className={styles.tableHead}>Sync Status</TableCell>
      <TableCell className={styles.tableHead}></TableCell>
    </TableRow>
  </TableHead>
);

export default ExpenseReportsTableHeader;
